import 'reflect-metadata'
import { define, type, auto, Record, Collection } from 'type-r'
import { openDB, deleteDB } from 'idb';

import Store from './store.js'

import TabForm from '#forms/tab.js'

@define
export default class TabStore extends Store {
    @(type(TabForm).events({"change": "formchange"}).as) tabForm: TabForm
}

const store = window.store = new TabStore({ id: "tab" })
export { store };
